import { getAppValue } from "src/utils/environment";

const BARKIO_CONTENT_VERSION = 4;
const BIBINO_CONTENT_VERSION = 3;

const currentContentVersion = getAppValue({
  barkio: BARKIO_CONTENT_VERSION,
  bibino: BIBINO_CONTENT_VERSION
});

export { currentContentVersion };
